// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[type=number][data-v-5f16e604]{display:inline;width:40px;height:26px}[dir] input[type=number][data-v-5f16e604]{padding:0 5px}", ""]);
// Exports
module.exports = exports;
